import { field, date, children, writer, relation,text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { JOURNAL_SCHEMA } from '../schema';

export default class Journal extends Model {
    static table = JOURNAL_SCHEMA;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
        staff: { type: 'belongs_to', key: 'staff_id' },
        attendance: { type: 'has_many', foreignKey: 'journal_id' }
    }

    @text('reference_id') reference_id;
    @text('description') description;
    @field('amount') amount;
    @text('type') type;

    @date('last_updated_at') last_updated_at;
    @date('created_at') created_at;

    @relation('business', 'business_id') business;
    @relation('staff', 'staff_id') staff;

    @children('attendance') attendance;

    @writer async updateSalaryJournal(data) {
        await this.update(journal => {
            journal.amount = data.new_salary
            journal.last_updated_at = data.last_updated_at
        })
    }

    @writer async updateJournalEntry(data) {
        await this.update(journal => {
            journal.last_updated_at = data.last_updated_at
            journal.amount = data.amount
            journal.description = data.description
            journal.created_at = data.created_at
        })
    }

    @writer async markAsDeleted() {
        await super.markAsDeleted();
    }
}